import React, { Suspense, lazy } from 'react';
import { Navigate, Outlet, Route } from 'react-router-dom';

// layouts
import DashboardLayout from '@layouts/dashboard';

// components
import { paths } from '@routes/paths';
import NotFoundPage from '@pages/NotFoundPage';

const ManagePatientPage = lazy(() => import('@pages/manage-patient'));

// ----------------------------------------------------------------------

export const securedRoutes = <Route path={paths.patient.root} element={<ManagePatientPage />} />;
